import { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Flex,
  FormControl,
  Heading,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Spinner,
  Stack,
  Text,
  useMediaQuery,
  VStack
} from '@chakra-ui/react'
import { ViewIcon, ViewOffIcon, WarningIcon, CloseIcon } from '@chakra-ui/icons'
import { Link, useNavigate } from 'react-router-dom'

import useAuth from '../../hooks/useAuth'
import SessionStartLogo from '../../components/SessionStartLogo'
import clientAxios from '../../config/axios'

const quilmesImages = require.context('../../assets/images', true)

const Login = () => {
  const { user, login, loginWithGoogle, setUserRegister } = useAuth()
  const [userLogin, setUserLogin] = useState({
    email: '',
    password: ''
  })
  const [errorEmail, setErrorEmail] = useState('')
  const [errorPassword, setErrorPassword] = useState('')
  const [error, setError] = useState('')
  const [isLoggedin, setIsLoggedin] = useState(false)
  const [errorVerify, setErrorVerify] = useState(false)
  const [errorResend, setErrorResend] = useState(false)
  const [isLargerThan768] = useMediaQuery('(min-width: 780px)')
  const [show, setShow] = useState(false)
  const handleClick = () => setShow(!show)
  const navigate = useNavigate()

  useEffect(() => {
    const userLogin = sessionStorage.getItem('user')
    const survey = sessionStorage.getItem('object')
    const products = sessionStorage.getItem('products')

    if (survey || products || userLogin) {
      sessionStorage.removeItem('user')
      sessionStorage.removeItem('object')
      sessionStorage.removeItem('products')
    }
  }, [])

  const handleGoogleSignin = async () => {
    try {
      const user = await loginWithGoogle()

      clientAxios.post('/auth/login', { idToken: user.user.accessToken, providerType: 2 })
        .then((res) => {
          if (res.status === 200) {
            setUserRegister(res.data)
            sessionStorage.setItem('user', JSON.stringify(res.data))
            navigate('/survey-information')
          }
        })
        .catch((err) => {
          console.log(err)
        })
    } catch (error) {
      setError(error.message)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    setIsLoggedin(true)
    const regexEmail = /[-.\w]+@([\w-]+\.)+[\w-]+/g

    if (userLogin.email === '') {
      setErrorEmail('Es necesario que completes este campo.')
      setIsLoggedin(false)

      return
    } else if (userLogin.password === '') {
      setErrorPassword('Es necesario que completes este campo.')
      setIsLoggedin(false)

      return
    } else if (!regexEmail.test(userLogin.email)) {
      setErrorEmail('El correo electrónico no es válido')
      setIsLoggedin(false)

      return
    }

    login(userLogin.email, userLogin.password)
      .then((res) => {
        if (!res.user.emailVerified) {
          setErrorVerify(true)
          setIsLoggedin(false)

          return
        }
        clientAxios.post('/auth/login', { idToken: res.user.accessToken, providerType: 1 })
          .then((response) => {
            if (response.status === 200) {
              setIsLoggedin(false)
              if (response.data.userType === 1) {
                setUserRegister(response.data)
                sessionStorage.setItem('user', JSON.stringify(response.data))
                navigate('/survey-information')
              } else if (response.data.userType === 2) {
                setUserRegister(response.data)
                sessionStorage.setItem('user', JSON.stringify(response.data))
                navigate('/survey-information')
              } else {
                setUserRegister(response.data)
                sessionStorage.setItem('user', JSON.stringify(response.data))
                navigate('/home')
              }
            }
          })
          .catch((err) => {
            console.log(err)
          })
      })
      .catch((err) => {
        if (err.code === 'auth/user-not-found') {
          setErrorEmail('El correo electrónico no está registrado.')
          setIsLoggedin(false)
        } else if (err.code === 'auth/wrong-password') {
          setErrorPassword('La contraseña es incorrecta.')
          setIsLoggedin(false)
        } else if (err.code === 'auth/too-many-requests') {
          setError('Demasiados intentos fallidos. Por favor, inténtalo más tarde.')
          setIsLoggedin(false)
        } else if (err.code === 'auth/user-disabled') {
          setError('Tu cuenta ha sido deshabilitada.')
          setIsLoggedin(false)
        }
      })
  }

  const handleClose = () => {
    setErrorVerify(false)
    setErrorResend(false)
  }

  const handleResend = (e) => {
    e.preventDefault()
    setErrorResend(true)

    clientAxios.post('/auth/sendVerificationEmail', {
      idToken: user.accessToken
    })
      .then((res) => {
        console.log(res)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  return (
    <Box
      className='boxInvited'
      display={{ md: 'flex' }}
      justifyContent={'center'}
    >
      <Box bg='white' className='login-container' mx={'auto'}>
        <VStack
          alignItems={'flex-start'}
          as='form'
          autoComplete='off'
          padding={'3rem 1rem 2rem 1rem'}
          w={{ base: '100%', md: '100%' }}
          onSubmit={handleSubmit}
        >
          <SessionStartLogo />
          <Heading fontSize={'1.5rem'} fontWeight={'400'} paddingTop={'3rem'}>
            Iniciar Sesión
          </Heading>
          <Text fontSize={'14px'} fontWeight={'400'}>
            ¿Todavía no tenes una cuenta?
            <Link to='/create-account'>
              <span className='create-count'> Crear cuenta</span>
            </Link>
          </Text>

          <Stack paddingTop={'2rem'} w={{ base: '100%', md: 400 }}>
            <FormControl
              className='floating-label-group'
              paddingBottom={4}
              onFocus={() => setError('')}
            >
              <Input
                className='input'
                id='email'
                name='email'
                placeholder={userLogin.email ? ' ' : '' }
                type='text'
                value={userLogin.email}
                onChange={(e) =>
                  setUserLogin({ ...userLogin, email: e.target.value })
                }
                onFocus={() => setErrorEmail('')}
                {...(errorEmail !== '' ? { borderColor: 'red.500' } : {})}
                _hover={{
                  ...(errorEmail !== '' ? { borderColor: 'red.500' } : {})
                }}
              />
              <label
                className='placeholder'
                htmlFor='email'
                {...(errorEmail !== '' ? { className: 'error-input' } : {})}
              >
                Correo electrónico
              </label>

              {errorEmail && (
                <Text
                  color='red.500'
                  fontSize={'12px'}
                  paddingLeft={'.5rem'}
                  paddingTop={'.5rem'}
                  w={{ base: '75%', md: 400 }}
                >
                  {errorEmail}
                </Text>
              )}
            </FormControl>

            <FormControl
              className='floating-label-group'
              onFocus={() => setError('')}
            >
              <InputGroup>
                <Input
                  className='input'
                  id='password'
                  name='password'
                  placeholder={userLogin.password ? ' ' : ''}
                  type={show ? 'text' : 'password'}
                  value={userLogin.password}
                  onChange={(e) =>
                    setUserLogin({ ...userLogin, password: e.target.value })
                  }
                  onFocus={() => setErrorPassword('')}
                  {...(errorPassword !== '' ? { borderColor: 'red.500' } : {})}
                  _hover={{
                    ...(errorPassword !== '' ? { borderColor: 'red.500' } : {})
                  }}
                />
                <label
                  className='placeholder'
                  htmlFor='password'
                  {...(errorPassword !== ''
                    ? { className: 'error-input' }
                    : {})}
                >
                  Contraseña
                </label>
                <InputRightElement width='4.5rem'>
                  <Button
                    _active={{ background: 'none' }}
                    _focusVisible={{ boxShadow: 'none' }}
                    _hover={{ background: 'none' }}
                    arial-label='Mostrar contraseña'
                    background={'none'}
                    marginLeft={'1.5rem'}
                    onClick={handleClick}
                  >
                    {show
                      ? (
                        <ViewIcon color='blackAlpha.700' />
                      )
                      : (
                        <ViewOffIcon color='blackAlpha.500' />
                      )}
                  </Button>
                </InputRightElement>
              </InputGroup>
              {errorPassword && (
                <Text
                  color='red.500'
                  fontSize={'12px'}
                  paddingLeft={'.5rem'}
                  paddingTop={'.5rem'}
                  w={{ base: '75%', md: 400 }}
                >
                  {errorPassword}
                </Text>
              )}
            </FormControl>

            {error && (
              <Box display={'flex'} gap={2}>
                <WarningIcon
                  bg={'red'}
                  border={'1px solid red'}
                  borderRadius={'50px'}
                  color={'#FFF'}
                />
                <Text
                  color='red.500'
                  fontSize={'12px'}
                  marginTop={'-.5rem'}
                  w={'95%'}
                >
                  {error}
                </Text>
              </Box>
            )}
          </Stack>
          <Box>
            <Link to='/validate-email'>
              <span className='forget-my-password'>Olvidé mi contraseña</span>
            </Link>
          </Box>
          {errorVerify && (
            <Box
              bg={'#3B3939'}
              borderRadius={'5px'}
              w={{ base: '100%', md: 400 }}
            >
              <Flex
              >
                {errorResend
                  ? (
                    <Text
                      color={'#FFFFFF'}
                      fontSize={'13px'}
                      padding={'1rem'}
                      w={{ base: '100%', md: '100%' }}
                    >
                      Reenviamos el correo electrónico. Recordá revisar la carpeta spam.
                    </Text>
                  )
                  : (
                    <Text
                      color={'#FFFFFF'}
                      fontSize={'13px'}
                      padding={'1rem'}
                      w={{ base: '100%', md: '100%' }}
                    >
                      El correo electrónico no fue verificado, es necesario que
                      completes la verificación para iniciar sesión. Recordá revisar
                      la carpeta spam.
                      <Text as={'span'} fontWeight={'700'}
                        onClick={handleResend}
                      >
                        <a href='/'>No recibí el correo.</a>
                      </Text>
                    </Text>
                  )}

                <Button
                  _active={{ bg: 'none' }}
                  _hover={{ bg: 'none' }}
                  bg={'none'}
                  marginTop={1}
                  onClick={handleClose}
                >
                  <CloseIcon color={'#FFFFFF'} h={3} w={3}/>
                </Button>
              </Flex>
            </Box>
          )}

          <Stack
            justifyContent='center'
            paddingTop={1}
            w={{ base: '100%', md: 400 }}
          >
            <Button
              _focusVisible={{ outline: 'none' }}
              type='submit'
              variant={'btn-quilmes'}
            >
              { isLoggedin
                ? <Spinner
                  color='#F5A97D'
                  emptyColor='white'
                  height={5}
                  size='xl'
                  speed='0.75s'
                  thickness='4px'
                  width={5}
                />
                : 'Iniciar Sesión' }
            </Button>
            <Link to='/login-invited'>
              <Button
                _active={{ bg: 'alpha.900', textColor: '#DB580B' }}
                _focusVisible={{ outline: 'none' }}
                _hover={{ bg: 'alpha.900', textColor: '#DB580B' }}
                bg='alpha.900'
                border={'1px solid #DB580B'}
                fontSize='0.8rem'
                marginTop='1'
                size='md'
                textColor='#DB580B'
                type='submit'
                w='100%'
              >
                Ingresar como invitado
              </Button>
            </Link>
          </Stack>
        </VStack>
        <Box textAlign={'center'}>
          <Text color={'#0A0808'} fontSize={'14px'}>
            Iniciar sesión con Google
          </Text>
          <Flex gap={4} justifyContent={'center'}>
            <Button
              _active={{ background: 'none' }}
              _hover={{ background: 'none' }}
              bg={'#FFF'}
              borderRadius={'50%'}
              h={'3rem'}
              marginTop={4}
              padding={0}
              w={'3rem'}
              onClick={handleGoogleSignin}
            >
              <Image
                alt='Google'
                objectFit={'cover'}
                src={quilmesImages('./google.svg')}
              />
            </Button>
            <Box display={'none'}>
              <Button
                _active={{ background: 'none' }}
                _hover={{ background: 'none' }}
                bg={'#FFF'}
                borderRadius={'50%'}
                h={'3rem'}
                marginTop={4}
                padding={0}
                w={'3rem'}
              >
                <Image
                  alt='Microsoft'
                  height={'3rem'}
                  src={quilmesImages('./microsoft.svg')}
                  width={'3rem'}
                />
              </Button>
            </Box>
          </Flex>
        </Box>
      </Box>
      <Box
        alignItems={'center'}
        bgColor={'#F7F7F7'}
        justifyContent={'center'}
        w={'50%'}
        {...(isLargerThan768
          ? { margin: '0', height: '100vh' }
          : { margin: '0 auto', height: 'auto' })}
      >
        {isLargerThan768
          ? (
            <Image
              alt='logo'
              h={'auto'}
              margin={0}
              mx={'auto'}
              objectFit='cover'
              padding={0}
              paddingTop={'2.5rem'}
              src={quilmesImages('./ilustracion.svg')}
              w={{ md: '50%' }}
            />
          )
          : null}
      </Box>
    </Box>
  )
}

export default Login
